import React, { Component } from "react";
import { connect } from "react-redux";
import { LegacyHeader } from "components/open/LegacyHeader";
import { LegacyFooter } from "components/open/LegacyFooter";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import classnames from "classnames";

import Styles from "components/open/Legacy.module.scss";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { Container } from "components/grid/Container";

class LegacyProduto extends Component {
  constructor (props) {
    super(props);

    this.state = {
      product: null,
      productReviews: null,

      productLoaded: false,
      productReviewsLoaded: false,
      productReviewLimit: 5
    };
  }

  productIncreaseLimit = () => {
    let length = this.state.productReviews.length,
        newLength = Math.min(
          this.state.productReviewLimit + 5, length
        );

    this.setState({
      productReviewLimit: newLength
    });
  };

  friendlyUrl = (url) => {
    return url.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "-").replace(/^-+|-+$/g, '');
  };

  componentDidMount () {
    const {
      location,
      history,
      match,
      token
    } = this.props;

    const {
      params 
    } = match;

    let productId = params.productId || null,
        productVariantId = params.productVariantId || null,
        productSlug = params.productSlug || null;

    if (
      productId
      && productVariantId
      && productSlug 
    ) {
      ExecuteRequest(
        GlamboxEndpoints.Open.getProductVariantDetail,
        null,
        "GET",
        null,
        {
          productVariantId
        },
        (response) => {
          let {
            result,
            statusCode
          } = response;
          
          if (statusCode === 200) {
            if (token === null) {
              window.location = "https://glambox.com.br/shopping";
            } else {
              let slug = this.friendlyUrl(result.productVariantName);
              if (slug === productSlug) {
                this.setState({
                  product: result,
                  productLoaded: true
                });

                this.loadProductReviews(productId);
              } else {
                if (token === null) {
                  window.location = "https://glambox.com.br/shopping";
                }
              }
            }
          } else {
            if (token === null) {
              window.location = "https://glambox.com.br/shopping";
            }
          }
        }
      );
    }
  }

  loadProductReviews = (productId) => {
    // TODO
    ExecuteRequest(
      GlamboxEndpoints.Open.productReviews,
      null,
      "GET",
      null,
      {
        productId: productId
      },
      (response) => {
        let {
          result,
          statusCode
        } = response;

        if (statusCode === 200) {
          this.setState({
            productReviews: result,
            productReviewsLoaded: true
          });
        } else {
          window.location = "https://glambox.com.br/shopping";
        }
      }
    );
  };

  drawRating = (rating) => {
    let stars = [];

    rating = Math.floor(rating);

    if (rating === 0) {
      for (let n = 0; n < 5; n++) {
        stars.push(
          <i key={n} className={classnames("fa", "fa-star", "rating-star", "empty")}/>
        );
      }
    } else {
      for (let n = 0; n < 5; n++) {
        if (n <= rating) {
          stars.push(
            <i key={n} className={classnames("fa", "fa-star", "rating-star", "full")}/>
          );
        } else {
          stars.push(
            <i key={n} className={classnames("fa", "fa-star", "rating-star", "empty")}/>
          );
        }
      }
    }

    return stars;
  };

  renderReviews = () => {
    if (this.state.productReviews.length < 1) {
      return null;
    }

    return this.state.productReviews.map((item, key) => {
      if (key >= this.state.productReviewLimit) return null;

      let commentDate = new Date(item.dateCreated);

      return (
        <div className={Styles["product__reviews-item"]} key={key}>
          <div className={Styles["name"]}>
            <h6 className={"mb-0"}>{item.nickname}</h6>
            <p>
              <small>{commentDate.toLocaleDateString("pt-BR")}</small>
            </p>
          </div>
          <div className={Styles["description"]}>
            <p className={Styles["lead"]}>
              {item.reviewTitle} <span>{this.drawRating(item.rating)}</span>
            </p>
            <p>{item.review}</p>
          </div>
        </div>
      );
    });
  }

  renderShowMoreButton = () => {
    if (this.state.productReviewLimit >= this.state.productReviews.length) {
      return null;
    }
    
    return (
      <p className={"text-center mt-5"}>
        <button className={"btn btn-lg btn-light-lime"} onClick={this.productIncreaseLimit}>
          VER MAIS
        </button>
      </p>
    );
  };

  render () {
    const {
      props, 
      state
    } = this;

    const {
      product,
      productReviews
    } = state;

    if (!state.productLoaded || !state.productReviewsLoaded) {
      return null;
    }

    return (
      <div className={Styles["legacy"]}>
        <LegacyHeader/>

        <div className={Styles["legacy__contents"]}>
          <Container className={"py-4"}>
            <div className={Styles["product"]}>
              <div className={Styles["product__image"]}>
                <img src={product.defaultImageURL.replace("_SML", "_BIG")} alt={""}/>
              </div>
              <div className={Styles["product__details"]}>
                <div className={Styles["product__title"]}>
                  <a className={Styles["product__title-brand"]} href={`https://glambox.com.br/edicoes/marca/${product.brandId}/${product.brandName}`}>
                    <img src={product.brandLogoImage} alt={""}/>
                  </a>
                  <h5>{product.productName}</h5>
                </div>

                <p className={"small"}>
                  {this.drawRating(product.ratingAverage)} &nbsp;&nbsp; Opiniões de {product.reviewCount} clientes
                </p>

                <div className={Styles["product__description"]} dangerouslySetInnerHTML={{__html: product.articleBody}}/>
              </div>
            </div>

            <hr/>

            <h5 className={"text-center"}>Avaliações de Clientes:</h5>

            <div className={Styles["product__reviews"]}>
              <div className={Styles["product__reviews-title"]}>
                <div className={Styles["about"]}>
                  <h5>Avaliação Geral</h5>
                  <p className={"small"}>{product.reviewCount} clientes</p>
                </div>
                <div className={Styles["rating"]}>
                  <h5>{this.drawRating(product.ratingAverage)}</h5>
                  <p className={"small"}>{product.ratingAverage} de 5 estrelas</p>
                </div>
              </div>
              {this.renderReviews()}
              {this.renderShowMoreButton()}
            </div>

          </Container>
        </div>

        <LegacyFooter/>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.token.data 
});

LegacyProduto = connect(mapStateToProps)(LegacyProduto);

export {
  LegacyProduto
};
